export interface ICurrentCalendarTrackingData {
  readonly dataAttribute: string;
  readonly value: string;
  readonly rowValueMap: Record<string, string>;
}

export const currentCalendarTrackingData: ICurrentCalendarTrackingData = {
  dataAttribute: 'intcmp',
  rowValueMap: {
    FP1: 'skyport_sportsdata_libere-1_null',
    FP2: 'skyport_sportsdata_libere-2_null',
    FP3: 'skyport_sportsdata_libere-3_null',
    FP4: 'skyport_sportsdata_libere-4_null',
    G: 'skyport_sportsdata_griglia_null',
    GS: 'skyport_sportsdata_griglia_null',
    Q: 'skyport_sportsdata_qualifiche_null',
    Q1: 'skyport_sportsdata_qualifiche-1_null',
    Q2: 'skyport_sportsdata_qualifiche-2_null',
    Q3: 'skyport_sportsdata_qualifiche-3_null',
    QS: 'skyport_sportsdata_qualifiche_null',
    R: 'skyport_sportsdata_gara_null',
    R1: 'skyport_sportsdata_gara-1_null',
    R2: 'skyport_sportsdata_gara-2_null',
    SPRINT: 'skyport_sportsdata_sprint-race_null',
    SS: 'skyport_sportsdata_sprint-shootout_null',
    SS1: 'skyport_sportsdata_sprint-shootout-1_null',
    SS2: 'skyport_sportsdata_sprint-shootout-2_null',
    SS3: 'skyport_sportsdata_sprint-shootout-3_null',
    W: 'skyport_sportsdata_warmup_null',
  },
  value: 'skysport_sportsdata_risultati-live_null',
};
